import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { PartCategoriesPage } from "src/components/views/erp/parts/partCategories/PartCategoriesPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/productManagement/partCategories")({
	staticData: { title: i18n.t("part_categories"), legacyViewKey: "partCategoryManagementView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <PartCategoriesPage />;
}
